import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import { isBefore } from 'date-fns';
import * as React from 'react';
import { useThemeContext } from '../../styles/themes/themes.js';
import { DateInputBase } from '../DateInput/DateInputBase.js';
import { DateSpinButton } from '../DateInput/DateSpinButton.js';
import { DatePicker } from '../DatePicker/DatePicker.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var _excluded = ["locale", "onChange", "modes", "presets", "value"];
var DateRangeInput = /*#__PURE__*/React.forwardRef(function DateRangeInput2(props, ref) {
  var _locale$formatLong;

  var _useThemeContext = useThemeContext(),
      i18n = _useThemeContext.i18n;

  var _props$locale = props.locale,
      locale = _props$locale === void 0 ? i18n.DatePicker.locale : _props$locale,
      _onChange = props.onChange,
      modes = props.modes,
      presets = props.presets,
      value = props.value,
      dateFieldBaseProps = _objectWithoutProperties(props, _excluded);

  var dateFormat = locale === null || locale === void 0 ? void 0 : (_locale$formatLong = locale.formatLong) === null || _locale$formatLong === void 0 ? void 0 : _locale$formatLong.date({
    width: "medium"
  });
  return /*#__PURE__*/jsx(DateInputBase, _objectSpread(_objectSpread({}, dateFieldBaseProps), {}, {
    closeButtonProps: {
      onClick: function onClick(e) {
        e.stopPropagation();

        _onChange([]);
      }
    },
    locale: locale,
    ref: ref,
    renderSpinButton: function renderSpinButton(spinButtonProps) {
      return /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(DateSpinButton, _objectSpread(_objectSpread({}, spinButtonProps), {}, {
          "aria-label": i18n.DateRangeInput.startButton,
          dateFormat: dateFormat,
          locale: locale,
          onChange: function onChange(date) {
            if (!value[1]) return _onChange([date]);
            if (isBefore(value[1], date)) return _onChange([date, date]);
            return _onChange([date, value[1]]);
          },
          value: value[0]
        })), /*#__PURE__*/jsx("div", {
          style: {
            marginLeft: 10,
            marginRight: 10
          },
          role: "presentation",
          children: "-"
        }), /*#__PURE__*/jsx(DateSpinButton, _objectSpread(_objectSpread({}, spinButtonProps), {}, {
          "aria-label": i18n.DateRangeInput.endButton,
          dateFormat: dateFormat,
          locale: locale,
          onChange: function onChange(date) {
            if (!value[0]) return _onChange([]);
            if (isBefore(date, value[0])) return _onChange([date, date]);
            return _onChange([value[0], date]);
          },
          value: value[1]
        }))]
      });
    },
    renderDatePicker: function renderDatePicker(datePickerProps) {
      return /*#__PURE__*/jsx(DatePicker, _objectSpread(_objectSpread({}, datePickerProps), {}, {
        variant: {
          modes: modes,
          onChange: _onChange,
          presets: presets,
          type: "range",
          value: value
        }
      }));
    }
  }));
});
DateRangeInput.propTypes = {
  "locale": _PropTypes.shape({
    "code": _PropTypes.string,
    "formatDistance": _PropTypes.func,
    "formatLong": _PropTypes.shape({
      "date": _PropTypes.func.isRequired,
      "dateTime": _PropTypes.func.isRequired,
      "time": _PropTypes.func.isRequired
    }),
    "formatRelative": _PropTypes.func,
    "localize": _PropTypes.shape({
      "day": _PropTypes.func.isRequired,
      "dayPeriod": _PropTypes.func.isRequired,
      "era": _PropTypes.func.isRequired,
      "month": _PropTypes.func.isRequired,
      "ordinalNumber": _PropTypes.func.isRequired,
      "quarter": _PropTypes.func.isRequired
    }),
    "match": _PropTypes.shape({
      "day": _PropTypes.func.isRequired,
      "dayPeriod": _PropTypes.func.isRequired,
      "era": _PropTypes.func.isRequired,
      "month": _PropTypes.func.isRequired,
      "ordinalNumber": _PropTypes.func.isRequired,
      "quarter": _PropTypes.func.isRequired
    }),
    "options": _PropTypes.shape({
      "firstWeekContainsDate": _PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]),
      "weekStartsOn": _PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6])
    })
  }),
  "modes": _PropTypes.arrayOf(_PropTypes.oneOf(["dynamic", "month", "week"])),
  "onChange": _PropTypes.func.isRequired,
  "presets": _PropTypes.bool,
  "value": _PropTypes.arrayOf(_PropTypes.instanceOf(Date))
};
DateRangeInput.displayName = "DateRangeInput";

export { DateRangeInput };
